module.exports = __webpack_public_path__ + "static/img/1_14_1.8c68c0c4.jpg";